const filterFormMobile = document.getElementById("filter-form-mobile");
const filterLabelsMobile = filterFormMobile?.querySelectorAll(".radio-input");
const filterGroupSummariesMobile = filterFormMobile?.querySelectorAll(".filter-group-summary");
const applyPriceButtonMobile = document.querySelector(".apply-drawer-filters");
const sortFormMobile = document.getElementById("sort-form-mobile");

filterLabelsMobile?.forEach((label) => {
	label.addEventListener("click", (e) => { 
		e.preventDefault();
		const input = label.querySelector("input");
		if (!input) return;

		input.checked = !input.checked;
		label.classList.toggle("active", input.checked);
	});
});

filterGroupSummariesMobile?.forEach((summary) => {
	summary.addEventListener("click", (e) => { 
		e.preventDefault();
		summary.parentNode?.classList.toggle("active");
	});
});

applyPriceButtonMobile?.addEventListener("click", (e) => { 
	e.preventDefault();
	if (!filterFormMobile) return;

	const finalParams = new URLSearchParams(new FormData(filterFormMobile));
	if ( Array.from(finalParams.keys()).some(key => key.startsWith("filter.v.option") ) ) finalParams.set("filter.v.availability", "1");

	let sortByValue = "";
	if (window.innerWidth <= 1024) {
		sortByValue = sortFormMobile?.querySelector("select")?.value;
	} else {
		const desktopSortForm = document.getElementById("sort-form");
		sortByValue = desktopSortForm?.querySelector("select")?.value;
	}
	if (sortByValue)
		finalParams.set("sort_by", sortByValue);

	const currentParams = new URLSearchParams(window.location.search);
	if (currentParams.has("q")) finalParams.set("q", currentParams.get("q"));
	if (currentParams.has("type")) finalParams.set("type", currentParams.get("type"));

	// 4. Redirect cleanly
	window.location.href = `${window.location.origin}${window.location.pathname}?${finalParams.toString()}`;
});